/**
 * created by xcc
 *平台维护
 */
import React, {Component} from "react";
import {Button, Icon, Input, Modal, Table, Upload, Pagination, Divider, Popconfirm} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import Title from "../../../components/title/Title";
import SpacerBlock from "../../../components/spacerBlock/SpacerBlock";
import {
    getAllNewMediaType,
    createNewMediaType,
    editNewMediaType,
    deleteNewMediaType
} from "../../actions/platformMaintenance";
import "./MaintenanceField.css";
import weChat from "../newMediaManagement/images/weChat.png";
import microBlog from "../newMediaManagement/images/microBlog.png";
import tiktok from "../newMediaManagement/images/tiktok.png";
import noImg from "../newMediaManagement/images/noImg.png";
import {getInfoFromLocalStorage, setInfoToLocalStorage} from "../../../../actions";
import {Scrollbars} from "react-custom-scrollbars";
import $ from 'jquery';
import BaseComponent from "../../../../base/BaseComponent";
import CmForm from "../../../../components/CmForm/CmForm";
import addImg from "./images/add.png";


function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
        message.error("只能上传JPG/PNG文件！");
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
        message.error("Image must smaller than 20MB!");
    }
    return isJpgOrPng && isLt2M;
}

export default class PlatformMaintenance extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            pageNum: 1,
            pageSize: 10,
            count: 0,
            addVisible: false,
            loading: false,
            modalTitle: "",
            editingMediaId: "",
            logoPic: "",
            titleName: "",
            hideOnSinglePage: false
        };
    }

    componentDidMount() {
        this.getList();
    }

    componentWillUnmount() {

    }

    render() {
        let height = window.innerHeight;
        return (
            <div>
                <div style={{margin: "15px 20px", height: height - 119}}>
                    {/*<Title title={"平台维护"}/>*/}
                    {/*<SpacerBlock height={1}/>*/}
                    <div style={{backgroundColor: "#fff", borderRadius:"5px 5px 0 0"}}>
                        <Button type="primary" style={{marginLeft: 20, marginTop: 20, marginBottom: 20}}
                                onClick={() => this.add()}>添加</Button>
                    </div>
                    {this.renderTable()}
                    {this.renderFooter()}
                    {this.renderAdd()}
                </div>
            </div>
        );
    }

    //渲染平台维护表格
    renderTable() {
        const columns = [
            {
                title: "平台名称",
                dataIndex: "name",
                key: "name",
                width: 250,
                ellipsis: true,
            },
            {
                title: "平台logo",
                dataIndex: "logoPath",
                key: "logoPath",
                width: 100,
                render: (text, record) => {
                    let logoPath;
                    switch (record.type) {
                        case 2:
                            logoPath = weChat;
                            break;
                        case 3:
                            logoPath = microBlog;
                            break;
                        case 5:
                            logoPath = tiktok;
                            break;
                        default :
                            logoPath = noImg;
                    }
                    return (
                        <div>
                            {
                                record.logoPath ?
                                    <img src={record.logoPath}
                                         style={{width: 25, height: 25, borderRadius: "50%", objectFit: "cover"}}/> : record.internal === 0 ?
                                        <img src={logoPath} style={{width: 25, height: 25, borderRadius: "50%", objectFit: "cover"}}/> : ""
                            }
                        </div>
                    );
                }
            },
            {
                title: "是否内置",
                dataIndex: "internal",
                key: "internal",
                render: text => (text === 0 ? "是" : "否")
            },
            {
                title: "添加人",
                dataIndex: "creator",
                key: "creator",
                ellipsis: true,
                /* render: (text, record) => {
                     let createName = "";
                     try {
                         createName = record.userInfo[0].name;
                     } catch (e) {
                         createName = "/";
                     }
                     return createName;
                 }*/
            },
            {
                title: "操作",
                dataIndex: "operation",
                key: "operation",
                render: (text, record) => {
                    return (
                        <div>
                            <span style={{color: "#0050B3", marginRight: 10, cursor: "pointer"}}
                                  onClick={() => this.editPlatform(record)}>编辑</span>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.maintenanceField(record)}>维护字段</span>
                            <Popconfirm
                                title={`确定删除媒体：${record.name}`}
                                onConfirm={() => this.delete(record)}
                                okText="确定"
                                cancelText="取消"
                            >
                                {
                                    record.internal === 0 ?
                                        "" : <span style={{color: "red", cursor: "pointer"}}>删除</span>
                                }
                            </Popconfirm>
                        </div>
                    );
                }
            }
        ];
        const {dataSource} = this.state;
        return (

            <div style={{background: "white", padding: "0px 20px 10px",borderRadius:this.state.dataSource.length && this.state.dataSource.length > 0 ? "" : "0 0 5px 5px"}} id={"table"}>
                <Scrollbars autoHide autoHeight autoHeightMax={window.innerHeight - 254}>
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        pagination={false}
                        rowKey="id"
                        rowClassName={this.getRowClassName}
                    />
                    <style>{`
                    #table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #table .ant-table-placeholder{border-bottom: 0;}
                `}</style>
                </Scrollbars>
            </div>
        );
    }

    //分页
    renderFooter() {
        return (
            <div style={{backgroundColor: "#fff", borderRadius:"0 0 5px 5px", display: !this.state.dataSource.length ? "none" : "block"}}>
                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    padding: 16,
                    borderTop: '1px solid #ebebeb',
                }}>
                    <Pagination
                        showQuickJumper
                        showSizeChanger
                        current={this.state.pageNum}
                        defaultPageSize={this.state.pageSize}
                        total={this.state.count}
                        showTotal={total => `共 ${total} 条 `}
                        onChange={(page, page_size) => this.onChangePage(page, page_size)}
                        onShowSizeChange={(page, page_size) => {
                            this.state.hideOnSinglePage = false;
                            this.onChangePage(page, page_size)
                        }}
                         hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div>
            </div>
        );
    }

    //渲染添加modal
    renderAdd() {
        const {logoPic, titleName, editingMediaId, loading, modalTitle, addVisible} = this.state;
        const uploadButton = (
            <div>
                <img style={{width: 100, height: 100, objectFit: "cover"}} src={addImg} alt={""}/>
            </div>
        );
        let Token = getInfoFromLocalStorage("Token");
        return (
            <Modal
                title={modalTitle}
                width={400}
                visible={addVisible}
                onOk={() => this.handleOk(editingMediaId)}
                okText={"保存"}
                onCancel={() => this.setState({addVisible: false, titleName: "", logoPic: "", editingMediaId: ""})}
                centered={true}
                maskClosable = {false}
            >
                <CmForm onSubmit={() => {
                    this.handleOk(editingMediaId)
                }}>
                    <div className="edit_wrap">
                        <div className="upload_wrap">
                            <Upload
                                name="file"
                                listType="picture-card"
                                className="avatar-uploader"
                                multiple={false}
                                showUploadList={false}
                                beforeUpload={beforeUpload}
                                customRequest={({file}) => {
                                    let url = "/storage/uploadFile";
                                    let fd = new FormData();
                                    fd.append("file", file);
                                    this.request({
                                        url,
                                        body: fd,
                                        method: "post",
                                        contentType: "upload",
                                        callBack: (file) => {
                                            let that = this;
                                            if (file) {
                                                let logoPic = file.path ? file.path : null;
                                                that.setState({
                                                    logoPic,
                                                    loading: false,
                                                })
                                            }
                                        },
                                        errorCallBack: () => {

                                        },
                                        serverVerify: {
                                            serverErrorCallBack: () => {

                                            }
                                        }
                                    });
                                }}
                            >
                                {
                                    logoPic ?
                                        <img src={logoPic} alt="avatar"
                                             style={{width: "100px", height: "100px", objectFit: "cover", borderRadius: "50%"}}/> :
                                        uploadButton
                                }
                            </Upload>
                        </div>
                        <div className="name_wrap">
                            <div><span style={{color: "red"}}>*</span> 平台名称：</div>
                            <Input type="text" value={titleName} placeholder={"请输入"}
                                   onChange={e => this.setState({titleName: e.target.value})}/>
                        </div>
                        <style>{`
                        .edit_wrap .ant-upload.ant-upload-select-picture-card > .ant-upload{padding: 0;}
                        `}</style>
                    </div>
                </CmForm>
            </Modal>
        );
    }

    //分页
    onChangePage(page, page_size) {
        this.state.pageNum = page;
        this.state.pageSize = page_size;
        this.getList();
    }

    //添加按钮
    add() {
        this.setState({
            addVisible: true,
            modalTitle: "新建平台",
            logoPic: "",
            titleName: ""
        });
    }

    // 编辑平台维护
    editPlatform(record) {
        const {name, logoPath, id} = record;
        let logo;
        switch (record.type) {
            case 2:
                logo = weChat;
                break;
            case 3:
                logo = microBlog;
                break;
            case 5:
                logo = tiktok;
                break;
            default :
                logo = "";
        }
        this.setState({
            addVisible: true,
            modalTitle: "编辑平台",
            editingMediaId: id,
            logoPic: logoPath ? logoPath : logo,
            titleName: name
        });
    }

    //保存  {创建 、 更新}
    handleOk(id) {
        const currentUserId = window.top.currentUser.id;
        const {
            modalTitle,
            logoPic,
            titleName,
            dataSource
        } = this.state;
        if (titleName.trim() === "") {
            return message.warn("平台名称不能为空！");
        }
        if (modalTitle === "新建平台") {
            // 创建数据
            const newMedia = {
                internal: 1,
                logoPath: logoPic ? logoPic : "",
                name: titleName
            };
            if (titleName.length > 15) {
                message.warn("平台名称不能超过15个字");
                return;
            }
            createNewMediaType(
                newMedia,
                res => {
                    // 创建成功的回调  还原数据 重新请求列表
                    message.success("创建成功");
                    this.getList();
                    this.setState({
                        addVisible: false,
                        logoPic: "",
                        titleName: ""
                    });
                }
            );
        } else {
            //更新数据
            //id
            const updateItem = dataSource.find(item => item.id === id);
            editNewMediaType(
                {
                    id,
                    logoPath: logoPic ? logoPic : "",
                    name: titleName
                },
                () => {
                    // 编辑成功回调
                    message.success("已修改");
                    this.getList();
                    this.setState({
                        addVisible: false,
                        logoPic: "",
                        titleName: ""
                    });
                }
            );
        }

    }

    //删除
    delete(record) {
        deleteNewMediaType(
            {newMediaTypeId: record.id},
            (res, status) => {
                if (status === 200) {
                    message.success("删除成功");
                    if (this.state.dataSource.length === 1 && this.state.pageNum > 1) {
                        this.onChangePage(this.state.pageNum - 1, this.state.pageSize)
                    } else {
                        this.onChangePage(this.state.pageNum, this.state.pageSize)
                    }
                } else {
                    message.error("删除失败");
                }
            }
        );
    }

    getList() {
        let {dataSource, count} = this.state;
        let params = {
            pageNum: this.state.pageNum,
            pageSize: this.state.pageSize,
        };
        getAllNewMediaType(params, (res) => {
                if (res) {
                    dataSource = res.data;
                    count = res.count;
                }
                this.setState({
                    dataSource,
                    count
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                });
            }
        );
    }

    //维护字段
    maintenanceField(record) {
        let params = {
            id: record.id,
            name: record.name
        };
        setInfoToLocalStorage("MaintenanceField", params);
        this.props.history.push("/view/newMediaMatrix/pms/platformMaintenance/maintenanceField/" + record.id);
    }
}